<script lang="ts">
  import { gql } from '@apollo/client';
  import { mutation } from "svelte-apollo";

  import type { ErrorSchema, UserData } from '../types';
  import Paper, { Title, Content } from '@smui/paper';
  import LoginForm from '../forms/LoginForm.svelte';
  import { loginFromResponse } from '../logic/login';

  let formData: UserData = {
    email: "",
    password: "",
  };
  let errors: ErrorSchema<UserData> = {
    message: "",
    fields: {
      email: "",
      password: "",
    }
  };

  const login = mutation(gql`
    mutation login($input: LoginInput!) {
      login(credentials: $input)
    }
  `);

  async function handleSubmit(event: Event) {
    event.preventDefault();
    try {
      let response: any = await login({
        variables: {
          input: {
            email: formData.email,
            password: formData.password,
          }
        }
      });
      loginFromResponse(response);
    } catch (error) {
      errors["message"] = error.message;
    }
  }
</script>

<div class="paper-container">
  <Paper>
    <Title>Log In</Title>
    <Content>
      <LoginForm submit={handleSubmit} errors={errors} bind:formData/>
    </Content>
  </Paper>
</div>
